import { render, staticRenderFns } from "./EquipmentCollapse.component.html?vue&type=template&id=37d4390e&scoped=true&external"
import script from "./EquipmentCollapse.component.ts?vue&type=script&lang=ts&external"
export * from "./EquipmentCollapse.component.ts?vue&type=script&lang=ts&external"
import style0 from "./EquipmentCollapse.component.scss?vue&type=style&index=0&id=37d4390e&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d4390e",
  null
  
)

export default component.exports